module.exports = __webpack_public_path__ + "img/customer_design_5@2x.af54ce9.jpg";